(function () {
  const threshold = 5000;
  const BEAR_VARIANT = '57557119631691';
  const PENGUIN_VARIANT = '57557117731147';
  const PAIR = {
    bear: { title: 'Silikon-Eisformen Bären', price: '€7,95', variantId: BEAR_VARIANT, url: '/products/silikon-eisformen-baren-4-niedliche-eiswurfel', img: '' },
    penguin: { title: 'Silikon-Eisformen Pinguine', price: '€7,95', variantId: PENGUIN_VARIANT, url: '/products/silikon-eisformen-pinguine-4-susse-eiswurfel', img: '' },
  };
  const fallbackUpsells = [
    { title: 'Reise-Parfümzerstäuber Set', price: '€4,65', variantId: '57557123006795', url: '/products/reise-parfumzerstauber-set-2-stuck-5-ml-aluminium', img: '' },
    { title: 'Make-up Schwämmchen Set', price: '€6,75', variantId: '57558248161611', url: '/products/make-up-schwammchen-set-15-teilig-pink-fuchsia-creme', img: '' },
    { title: 'Reiseflaschen-Set 9-in-1', price: '€5,70', variantId: '57557131297099', url: '/products/reiseflaschen-set-9-in-1-kosmetik-behalter-fur-unterwegs', img: '' },
  ];

  let refreshTimer;
  let lastSignature = '';
  let building = '';
  const recsCache = {};

  function ensureLegacyHidden() {
    if (document.getElementById('amx-hide')) return;
    const s = document.createElement('style');
    s.id = 'amx-hide';
    s.textContent = '#CartDrawer [class*="am-drawer-conv"],#CartDrawer [class*="am-cart-conv"]{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  function formatMoney(cents) {
    return '€' + (Math.max(cents, 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  function fetchRecommendations(productId) {
    if (!productId) return Promise.resolve([]);
    if (recsCache[productId]) return recsCache[productId];
    recsCache[productId] = (async () => {
      for (const intent of ['complementary', 'related']) {
        try {
          const r = await fetch(`/recommendations/products.json?product_id=${productId}&intent=${intent}&limit=10`, { credentials: 'same-origin' });
          if (!r.ok) continue;
          const d = await r.json();
          if (d && d.products && d.products.length) return d.products;
        } catch (e) {}
      }
      return [];
    })();
    return recsCache[productId];
  }

  function recToCard(p) {
    if (!p) return null;
    let variant = (p.variants || []).find((v) => v.available);
    if (!variant) variant = (p.variants || [])[0];
    if (!variant) return null;
    return {
      title: p.title,
      price: formatMoney(p.price),
      url: p.url || ('/products/' + p.handle),
      img: p.featured_image || (p.images && p.images[0]) || '',
      variantId: String(variant.id),
    };
  }

  function cardHtml(c) {
    if (!c) return '';
    const imgHtml = c.img
      ? `<img src="${esc(c.img)}" alt="" loading="lazy">`
      : `<span class="amx-thumb"></span>`;
    return `
      <div class="amx-cardA">
        ${imgHtml}
        <div class="amx-info">
          <a class="amx-t" href="${esc(c.url)}">${esc(c.title)}</a>
          <div class="amx-p">${esc(c.price)} · ideal als Ergänzung</div>
        </div>
        <button type="button" class="amx-add" data-amx-add="${esc(c.variantId)}" aria-label="Hinzufügen">+</button>
      </div>
    `;
  }

  async function render(cart) {
    ensureLegacyHidden();
    const footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || !cart) return;

    const items = cart.items || [];
    const variantIds = items.map((i) => String(i.variant_id || i.id));
    const productIds = items.map((i) => String(i.product_id));

    let anchor = null, maxp = -1;
    for (const it of items) {
      const p = (it.final_price != null ? it.final_price : it.price) || 0;
      if (p > maxp) { maxp = p; anchor = it; }
    }
    const anchorPid = anchor ? String(anchor.product_id) : '';

    const hasBear = variantIds.includes(BEAR_VARIANT);
    const hasPenguin = variantIds.includes(PENGUIN_VARIANT);
    let pairCard = null;
    if (hasBear && !hasPenguin) pairCard = PAIR.penguin;
    else if (hasPenguin && !hasBear) pairCard = PAIR.bear;

    const signature = `${cart.item_count}:${cart.total_price}:${anchorPid}:${pairCard ? pairCard.variantId : 'none'}`;
    const existing = footer.querySelector('.amx-conv');
    if (existing && signature === lastSignature) return;
    if (building === signature) return;
    building = signature;

    let card = null;
    if (pairCard) {
      card = pairCard;
    } else if (anchorPid) {
      const recs = await fetchRecommendations(anchorPid);
      const pick = recs.find((p) => !productIds.includes(String(p.id)) && (p.variants || []).some((v) => v.available));
      card = recToCard(pick);
    }
    if (!card) {
      card = fallbackUpsells.find((u) => !variantIds.includes(String(u.variantId))) || null;
    }

    const remaining = threshold - cart.total_price;
    const progress = Math.min(100, Math.max(0, Math.round((cart.total_price / threshold) * 100)));
    let message = 'Kostenloser Versand ab €50.';
    if (cart.item_count && remaining > 0) message = `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand`;
    if (cart.item_count && remaining <= 0) message = 'Kostenloser Versand erreicht ✓';

    const crossHtml = card ? `<div class="amx-h">Schnell dazu legen</div>${cardHtml(card)}` : '';

    const block = document.createElement('div');
    block.className = 'amx-conv';
    block.innerHTML = `
      <style>
        #CartDrawer [class*="am-drawer-conv"],#CartDrawer [class*="am-cart-conv"]{display:none!important}
        .amx-conv{font-family:var(--font-body-family);display:grid;gap:14px;margin:2px 0 16px;padding:16px 2px 2px;border-top:1px solid rgba(28,26,23,.10);background:transparent}
        .amx-ship{display:grid;gap:8px}
        .amx-ship strong{display:block;font-weight:600;font-size:13px;line-height:1.4;color:rgba(28,26,23,.85);letter-spacing:.01em}
        .amx-bar{overflow:hidden;height:4px;border-radius:999px;background:rgba(28,26,23,.08)}
        .amx-fill{display:block;height:100%;border-radius:inherit;background:rgba(122,31,61,.55)}
        .amx-trust{display:flex;flex-wrap:wrap;gap:6px 16px;font-size:11.5px;color:rgba(28,26,23,.52);letter-spacing:.01em}
        .amx-trust span{display:inline-flex;align-items:center;gap:6px}
        .amx-trust span::before{content:"";flex:none;width:5px;height:9px;border:solid rgba(122,31,61,.65);border-width:0 1.5px 1.5px 0;transform:rotate(45deg);margin-bottom:2px}
        .amx-h{font-size:10.5px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:rgba(28,26,23,.42)}
        .amx-cardA{display:grid;grid-template-columns:auto 1fr auto;gap:12px;align-items:center;padding:10px 12px;border:1px solid rgba(28,26,23,.10);border-radius:10px;background:#fff}
        .amx-cardA img,.amx-thumb{width:44px;height:44px;border-radius:8px;object-fit:cover;background:#f1ebe1;flex:none;display:block}
        .amx-info{min-width:0}
        .amx-t{font-size:12.5px;font-weight:600;line-height:1.25;color:#1C1A17;text-decoration:none;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .amx-p{font-size:11.5px;color:rgba(28,26,23,.55);margin-top:2px}
        .amx-add{flex:none;width:34px;height:34px;border-radius:999px;border:1.5px solid rgba(122,31,61,.7);background:#fff;color:#7a1f3d;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s ease,color .15s ease}
        .amx-add:hover{background:#7a1f3d;color:#fff}
      </style>
      <div class="amx-ship">
        <strong>${message}</strong>
        <div class="amx-bar" aria-hidden="true"><span class="amx-fill" style="width:${progress}%"></span></div>
      </div>
      <div class="amx-trust" aria-label="Shop Vorteile"><span>DHL 1–3 Tage</span><span>30 Tage Rückgabe</span><span>Sicher bezahlen</span></div>
      ${crossHtml}
    `;

    const current = footer.querySelector('.amx-conv');
    if (current) current.remove();
    footer.insertBefore(block, footer.firstElementChild);
    lastSignature = signature;
    building = '';
  }

  async function refresh() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      await render(await response.json());
    } catch (error) { building = ''; }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 150);
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-amx-add]');
    if (!button) return;
    button.disabled = true;
    button.textContent = '…';
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: button.dataset.amxAdd, quantity: 1 }) });
      window.location.href = '/cart';
    } catch (error) {
      button.disabled = false;
      button.textContent = '+';
    }
  });

  document.addEventListener('DOMContentLoaded', () => { ensureLegacyHidden(); scheduleRefresh(); });
  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('DOMContentLoaded', () => {
    const target = document.querySelector('cart-drawer') || document.body;
    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(target, { childList: true, subtree: true });
  });
})();